import React, { useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import IosShareIcon from "@mui/icons-material/IosShare";

const InvoiceFilters = ({
  buildingList,
  selectBuildings,
  setSelectBuildings,
  handleExport,
}) => {
  const [openBuilding, setOpenBuilding] = useState(false);

  const handleBuildingChange = (event, newValue) => {
    setSelectBuildings(newValue); // Update selected buildings
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: 2,
        }}
      >
        <Typography variant="h5" sx={{ color: "#333", fontWeight: "bold" }}>
          Search Filters
        </Typography>
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            sx={{
              color: "green",
              borderColor: "green",
              "&:hover": { backgroundColor: "rgba(0, 128, 0, 0.1)" },
            }}
            startIcon={<IosShareIcon />}
            onClick={() => handleExport("excel", "stock")}
          >
            Export to Excel
          </Button>
          <Button
            variant="outlined"
            sx={{
              color: "#A52A2A",
              borderColor: "#A52A2A",
              "&:hover": { backgroundColor: "rgba(165, 42, 42, 0.1)" },
            }}
            startIcon={<IosShareIcon />}
            onClick={() => handleExport("pdf", "stock")}
          >
            Export to PDF
          </Button>
        </Stack>
      </Box>

      <Stack direction={{ xs: "column", md: "row" }} spacing={2} sx={{ p: 2 }}>
        {/* Building Filter */}
        <Box sx={{ minWidth: { xs: 250, md: 300 } }}>
          <FormControl fullWidth>
            <Autocomplete
              multiple
              open={openBuilding}
              onOpen={() => setOpenBuilding(true)}
              onClose={() => setOpenBuilding(false)}
              options={buildingList} // Simplified list of objects { id, building_name }
              value={selectBuildings} // Array of selected buildings with IDs and names
              onChange={handleBuildingChange}
              getOptionLabel={(option) => option.building_name} // Display only building names
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Building"
                  placeholder="Select Buildings"
                  variant="outlined"
                  sx={{ borderRadius: "8px" }}
                />
              )}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox checked={selected} />
                  {option.building_name}
                </li>
              )}
            />
          </FormControl>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Button
            variant="contained"
            sx={{
              minWidth: 150,
              minHeight: 45,
              backgroundColor: "#6c757d",
              color: "white",
              "&:hover": { backgroundColor: "#5a6268" },
              borderRadius: "8px",
              boxShadow: 2,
            }}
            onClick={() => setSelectBuildings([])} // Clear building selection
          >
            Clear Filters
          </Button>
        </Box>
      </Stack>
    </>
  );
};

export default InvoiceFilters;
